/**
 * Splice a dictated snippet into an existing string at the given caret
 * position, inserting a space before/after when needed so dictated words
 * don't jam into surrounding text. Trailing space is skipped when the
 * next character is already whitespace or punctuation that shouldn't
 * have a space before it (comma, full stop, close-bracket, quote, etc.).
 */
export const spliceDictatedText = (base: string, caret: number, spoken: string): string => {
  if (!spoken) return base;
  const before = base.slice(0, caret);
  const after = base.slice(caret);
  const needsLeadingSpace = before.length > 0 && /\S$/.test(before);
  const needsTrailingSpace = after.length > 0 && /^[^\s.,;:!?)\]}"']/.test(after);
  const insertion = `${needsLeadingSpace ? ' ' : ''}${spoken}${needsTrailingSpace ? ' ' : ''}`;
  return before + insertion + after;
};
